import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Trophy, Gift, Cpu, ArrowRight } from 'lucide-react';

// Homepage competition promo strip — surfaces the free monthly + £5 six-monthly
// sim rig draws to every visitor and funnels them to /competition.
export default function CompetitionStrip() {
  return (
    <section className="py-16 px-6 lg:px-10 border-t border-white/5">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="relative overflow-hidden bg-[#111115] border border-primary/30"
        >
          {/* accent glow + carbon texture */}
          <div className="absolute inset-0 bg-gradient-to-br from-primary/20 via-transparent to-transparent pointer-events-none" />
          <div className="absolute inset-0 carbon-bg opacity-40 pointer-events-none" />

          <div className="relative grid grid-cols-1 lg:grid-cols-2 gap-px bg-primary/20">
            {/* FREE MONTHLY DRAW */}
            <div className="bg-[#111115] p-8 lg:p-10 flex flex-col justify-center">
              <div className="flex items-center gap-2 mb-4">
                <Gift className="w-4 h-4 text-primary" />
                <p className="text-primary text-[11px] font-bold tracking-[0.3em]">FREE · EVERY MONTH</p>
              </div>
              <h3 className="text-white font-black text-2xl md:text-3xl uppercase leading-[0.95] mb-3">
                Win a Free<br />Sim Racing Experience
              </h3>
              <p className="text-white/50 text-sm leading-relaxed max-w-sm mb-6">
                One entry per month. No cost, no catch — just a free session at our Bromborough venue up for grabs.
              </p>
              <Link
                to="/competition"
                className="inline-flex items-center gap-2 bg-primary hover:bg-primary/90 text-white font-bold text-xs tracking-widest px-5 py-3 transition-colors w-fit"
              >
                ENTER FREE DRAW <ArrowRight className="w-3.5 h-3.5" />
              </Link>
            </div>

            {/* £5 SIM RIG DRAW */}
            <div className="bg-[#0d0d0f] p-8 lg:p-10 flex flex-col justify-center border-t lg:border-t-0 lg:border-l border-primary/20">
              <div className="flex items-center gap-2 mb-4">
                <Cpu className="w-4 h-4 text-primary" />
                <p className="text-primary text-[11px] font-bold tracking-[0.3em]">SIX-MONTHLY · £5 ENTRY</p>
              </div>
              <h3 className="text-white font-black text-2xl md:text-3xl uppercase leading-[0.95] mb-3">
                Win a Full<br />Pro-Spec Sim Rig
              </h3>
              <p className="text-white/50 text-sm leading-relaxed max-w-sm mb-6">
                Every six months one winner takes home a complete pro-spec sim racing rig. £5 per entry, UK residents.
              </p>
              <Link
                to="/competition?paid=rig"
                className="inline-flex items-center gap-2 border border-primary hover:bg-primary text-white font-bold text-xs tracking-widest px-5 py-3 transition-colors w-fit"
              >
                WIN A SIM RIG · £5 <ArrowRight className="w-3.5 h-3.5" />
              </Link>
            </div>
          </div>

          {/* trophy tag */}
          <div className="relative flex items-center gap-2 px-8 lg:px-10 py-4 bg-primary/10 border-t border-primary/20">
            <Trophy className="w-4 h-4 text-primary" />
            <p className="text-white/70 text-[11px] font-bold tracking-widest uppercase">
              Motion Reality Competitions · Open to UK residents
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
}